import _ from "lodash";
/** External */
import client from "lib/apolloClient/client";

/** Internal */
import {
  getOverviewMetricsQuery,
  getTableMetricsQuery,
  getGraphDataQuery,
  getOrganizationGradesQuery,
  getOrganizationSubjectsQuery,
  getOrganizationPointSetQuery,
  getStaffCurriculumQuery,
  getAnalyticsEntityQuery,
  getGradingPeriodsQuery,
  getBehaviourModuleNomenclatureQuery,
  getLastSyncTimeQuery,
  getOrganizationLearningCoursesQuery,
} from "./ToddleAnalyticsQueries";

export const getOverviewMetricsFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getOverviewMetricsQuery,
      variables,
    });
    return _.get(queryData, "node") || {};
  } catch (e) {
    return {};
  }
};

export const getTableMetricsFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getTableMetricsQuery,
      variables,
    });
    return _.get(queryData, "node") || {};
  } catch (e) {
    return {};
  }
};

export const getGraphDataFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getGraphDataQuery,
      variables,
    });
    return _.get(queryData, "node") || {};
  } catch (e) {
    return {};
  }
};

export const getOrganizationGradesFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationGradesQuery,
      variables,
    });
    return _.get(queryData, "node") || {};
  } catch (e) {
    return {};
  }
};

export const getOrganizationSubjectsFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationSubjectsQuery,
      variables,
    });
    return _.get(queryData, "node") || {};
  } catch (e) {
    return {};
  }
};

export const getOrganizationLearningCoursesFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationLearningCoursesQuery,
      variables,
    });
    return _.get(queryData, "node") || {};
  } catch (e) {
    return {};
  }
};

export const getOrganizationPointSetFromCache = ({ variables }) => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationPointSetQuery,
      variables,
    });
    return _.get(queryData, "node") || {};
  } catch (e) {
    return {};
  }
};

export const getStaffCurriculumFromCache = variables => {
  try {
    const result = client.readQuery({
      query: getStaffCurriculumQuery,
      variables,
    });

    return _.get(result, "platform.staff[0]", []);
  } catch (error) {
    return {};
  }
};

export const getAnalyticsEntityFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getAnalyticsEntityQuery,
      variables,
    });
    return _.get(queryData, "node") || {};
  } catch (e) {
    return {};
  }
};

export const getGradingPeriodsFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getGradingPeriodsQuery,
      variables,
    });
    return _.get(queryData, "node") || {};
  } catch (e) {
    return {};
  }
};

export const getBehaviourModuleNomenclatureFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getBehaviourModuleNomenclatureQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getLastSyncTimeFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getLastSyncTimeQuery,
      variables,
    });
    return _.get(queryData, "node") || {};
  } catch (e) {
    return {};
  }
};
